export * from '@fhs/routing/src/routes/v2/[staticPage]/_layout';
export { default } from '@fhs/routing/src/routes/v2/[staticPage]/_layout';
